import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {hideNotification} from '../reducers/reducer';
import Notification from 'modules/Common/components/Notification';

require('./InsiderNotification.scss');

export class PureInsiderNotification extends Component {
    static propTypes = {
        onHideNotification: PropTypes.func.isRequired,
        showNotification: PropTypes.bool.isRequired,
        userFirstName: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.dismiss = this.dismiss.bind(this);
    }

    dismiss() {
        this.props.onHideNotification();
    }

    render() {
        if (!this.props.showNotification) {
            return null;
        }

        return ( 
        <Notification showClose={true} onDismiss={this.dismiss} className="insider-notification">
            <div>
                <p>Thanks for becoming an <strong>Insider</strong>, {this.props.userFirstName}! 
                You can now access My Stable, video replays, score updates and lots more.                     
                </p>
            </div>
        </Notification>        
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onHideNotification: () => {
            dispatch(hideNotification())
        }
    }
}

const mapStateToProps = state => {
    let firstName = ''
    if (state.common.auth && state.common.auth.user && state.common.auth.user.firstname) {
        firstName = state.common.auth.user.firstname
    }

    return {
        showNotification: state.insider.showNotification,
        userFirstName: firstName
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PureInsiderNotification);



// WEBPACK FOOTER //
// ./modules/Insider/containers/InsiderNotification.js